import React from 'react';
import _ from 'lodash';
import numeral from 'numeral';
import moment from 'moment';
import { Card, Message, Grid, Statistic, Table, Icon, Label } from 'semantic-ui-react';
import { Doughnut, HorizontalBar } from 'react-chartjs-2';
import ReactPlayer from 'react-player';
import Chart from '../../components/chart';


const cf = num => numeral(num).format(0, 0);

const displayBlock = {
  display: 'block',
};

const barOptions = {
  tooltips: {
    mode: 'index',
    intersect: false,
  },
  responsive: true,
  showScale: false,
  scales: {
    xAxes: [{
      stacked: true,
    }],
    yAxes: [{
      stacked: true,
    }],
  },
};

const youtubeVideoStyle = {
  maxWidth: '640px',
};

const getTimeStamp = post => (moment(post.latestStatistic.createdDate).format('MMMM Do YYYY, h:mm:ss a'));

const ReportHeroContent = ({ mainData, heroPost }) => (
  <Card fluid color="red">
    <Card.Content>
      <Message icon>
        <Icon name="youtube play" color="red" />
        <Message.Content>
          <Message.Header>{ mainData.title }</Message.Header>
          { mainData.subTitle }
        </Message.Content>
      </Message>
      <Grid>
        <Grid.Row>
          <Grid.Column computer={10} mobile={16}>
            <ReactPlayer width="100%" url={mainData.videoUrl} controls style={youtubeVideoStyle} />
          </Grid.Column>
          <Grid.Column computer={6} mobile={16} textAlign="center">
            <div>
            &nbsp;
              <Statistic color="pink" size="small" style={displayBlock}>
                <Statistic.Value>
                  { cf(mainData.views) }
                </Statistic.Value>
                <Statistic.Label>
                  <Icon name="youtube play" />
                views
                </Statistic.Label>
              </Statistic>

              <Statistic color="pink" size="small" style={displayBlock}>
                <Statistic.Value>
                  { cf(mainData.engagements) }
                </Statistic.Value>
                <Statistic.Label>
                  <Icon name="like" />
                engagements
                </Statistic.Label>
              </Statistic>
            &nbsp;

              <Statistic color="pink" size="small" style={displayBlock}>
                <Statistic.Value>
                  { cf(mainData.watchTimeUKIre) }
                </Statistic.Value>
                <Statistic.Label>
                  <Icon name="clock" />
                watch time UK/Ire (mins)
                </Statistic.Label>
              </Statistic>
            &nbsp;

              <Statistic color="pink" size="small" style={displayBlock}>
                <Statistic.Value>
                  { cf(mainData.watchTimeTotal) }
                </Statistic.Value>
                <Statistic.Label>
                  <Icon name="clock" />
                watch time total (mins)
                </Statistic.Label>
              </Statistic>
            &nbsp;

            </div>

          </Grid.Column>
        </Grid.Row>

      </Grid>

    </Card.Content>
    <Card.Content>

      <Grid>
        <Grid.Row>
          <Grid.Column computer={4} mobile={16}>
            <h4>Who&apos;s watching? (views by gender)</h4>
            <Doughnut data={mainData.donutData} />
          </Grid.Column>
          <Grid.Column computer={6} mobile={16}>


            <h4>Who’s watching? (avg. watch time by age/gender)</h4>
            <HorizontalBar data={mainData.barData} options={barOptions} />


          </Grid.Column>
          <Grid.Column computer={6} mobile={16} verticalAlign="middle">


            <h4 style={{ marginTop: '20px', marginBottom: '5px' }}>Where are they watching?</h4>

            <Table celled stackable fluid size="small" basic="very" textAlign="center">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>country</Table.HeaderCell>
                  <Table.HeaderCell>watch time</Table.HeaderCell>
                  <Table.HeaderCell>views</Table.HeaderCell>
                  <Table.HeaderCell>likes</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>

                {
                  _.map(mainData.viewingData, d => (
                    <Table.Row>
                      <Table.Cell>{ d.name }</Table.Cell>
                      <Table.Cell>{ cf(d.watchTime * (mainData.scaleFactor || 1)) }</Table.Cell>
                      <Table.Cell>{ cf(d.views * (mainData.scaleFactor || 1)) }</Table.Cell>
                      <Table.Cell>{ cf(d.likes * (mainData.scaleFactor || 1)) }</Table.Cell>
                    </Table.Row>
                  ))
                }

              </Table.Body>
            </Table>

         &nbsp;

          </Grid.Column>
        </Grid.Row>
      </Grid>

    </Card.Content>


    { heroPost &&
      <Card.Content textAlign="center">
        <h4>Total and Daily Viewing over time</h4>
        <Chart trackedAsset={heroPost} />
        <Label
          centered
          icon="clock"
          color="grey"
          basic
          content={`data collected ${getTimeStamp(heroPost)}`}
        />
      </Card.Content>
    }
    <Card.Content extra>
      youtube engagements are calculated as likes + comments + shares
    </Card.Content>

  </Card>
);

export default ReportHeroContent;



// WEBPACK FOOTER //
// ./src/components/report-hero-content/index.js